const isDesktop = window.innerWidth > 900;
export default isDesktop;
